import { ArrowRightOutline18Icon } from "@vygruppen/spor-icon-react";
import { TrainIdentifier } from "@vygruppen/vy-train-map";
import { AltTransTrainId } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";
import { generatePath, Link } from "react-router-dom";
import { DropsButton } from "shared/components/Spor";
import { TRAIN } from "shared/utils/routes";

type TrainDetailsButtonProps = ForAltTransPlanningTrainId | ForTrainIdentifier;

type ForAltTransPlanningTrainId = {
  altTransPlanningTrainId: AltTransTrainId;
  trainIdentifier?: undefined;
};

type ForTrainIdentifier = {
  trainIdentifier: TrainIdentifier;
  altTransPlanningTrainId?: undefined;
};

export const TrainDetailsButton: FC<TrainDetailsButtonProps> = ({
  altTransPlanningTrainId,
  trainIdentifier,
}) => {
  const countryCode =
    altTransPlanningTrainId?.countryCode ??
    trainIdentifier?.countryCode ??
    null;
  const trainNumber =
    altTransPlanningTrainId?.id ?? trainIdentifier?.identifier ?? null;
  const trainDate =
    altTransPlanningTrainId?.nominalDate ??
    trainIdentifier?.nominalDate ??
    null;

  return (
    <Link
      to={generatePath(TRAIN, {
        countryCode,
        trainNumber,
        trainDate,
      })}
    >
      <DropsButton
        variant="ghost"
        size="xs"
        rightIcon={<ArrowRightOutline18Icon />}
      >
        Togdetaljer
      </DropsButton>
    </Link>
  );
};
